/* global moment */
import { application } from 'services/core'

function SubscriptionPromotion () {
  const elements = {}

  const initializeSelectors = () => {
    elements.subscriptionPromotionId = document.querySelector('#subscription_promotion_id')?.value
    elements.stores = document.querySelector('#stores')
    elements.serviceType = document.querySelector('#service_types')
    elements.promotionType = document.querySelector('#subscription_promotion_type')
    elements.generalDiscount = document.querySelector('#subscription_general_discount')
    elements.enableDiscountFields = document.querySelector('#enable_general_discount_fields')
    elements.serviceTypeMulti = document.querySelector('#subscription_promotion_service_type_ids')
    elements.categoryIdsMulti = document.querySelector('#subscription_promotion_category_ids')
    elements.discountMulti = document.querySelector('#subscription_promotion_included_discount')
    elements.startDate = document.querySelector('#subscription_promotion_start_date')
    elements.endDate = document.querySelector('#subscription_promotion_end_date')
    elements.dayTimeSelector = document.querySelector('#subscription_promotion_day_time_selector')
    elements.subscriptionForm = document.querySelector('#subscritpion_promotion_form')
    elements.serviceTypeFilter = document.querySelector('#subscription_service_type_filter')
    elements.categoryFilter = document.querySelector('#subscription_category_filter')
    elements.promotionRuleFilter = document.querySelector('#subscription_promotion_rule_filter')
    elements.subscriptionServiceTypes = document.querySelector('#subscription_service_types')
    elements.subscriptionCategories = document.querySelector('#subscription_categories')
    elements.promotionRuleFields = document.querySelector('#promotion_rule_base_fields')
    elements.submitButton = document.querySelector('#subscription_promotion_submit_btn')
    elements.cashbackDiscount = document.querySelector('#subscription_promotion_cashback_discount')
    elements.enableTopListing = document.querySelector('#subscription_promotion_enable_top_listing')
    elements.enableM4bPortal = document.querySelector('#subscription_promotion_enable_m4b_portal')
    elements.indexListingTable = document.querySelector('#subscription_promotion_listing')
    elements.showListingTable = document.querySelector('#subscription_promotion_services')
    elements.serviceTypesTable = document.querySelector('#subscription_promotion_service_types')
    elements.categoriesTable = document.querySelector('#subscription_promotion_categories')
  }

  const initializeListeners = () => {
    $(elements.generalDiscount).on('change', toggleFieldsOnGeneralDiscount)
    $(elements.dayTimeSelector).on('click', toggleShifts)
    $(elements.serviceTypeFilter).on('click', toggleServiceTypes)
    $(elements.categoryFilter).on('click', toggleCategories)
    $(elements.submitButton).on('click', validateFields)
    $(elements.promotionRuleFilter).on('click', toggleGeneralDiscount)
    $(elements.startDate).on('dp.show', openStartDatePicker)
    $(elements.startDate).on('dp.change', validateDuration)
    $(elements.endDate).on('dp.show', openEndDatePicker)
  }

  const initializeDataTable = (element) => {
    $(element).DataTable({
      'paging': true,
      'lengthMenu': [[10, 25, 50, 200], [10, 25, 50, 200]],
      'lengthChange': true,
      'searching': false,
      'ordering': true,
      'order': [],
      'info': true,
      'autoWidth': false
    })
  }

  const openStartDatePicker = () => {
    $(elements.startDate).data('DateTimePicker').minDate(new Date())
  }

  const openEndDatePicker = () => {
    $(elements.endDate).data('DateTimePicker').minDate($(elements.startDate).val())
  }

  const validateDuration = () => {
    const startDate = $(elements.startDate).val()
    const endDate = $(elements.endDate).val()

    if (startDate > endDate) {
      $(elements.endDate).data('DateTimePicker').date(startDate)
    }
  }

  const toggleShifts = () => {
    const isChecked = elements.dayTimeSelector?.checked
    $('#day_time_selector_part').attr('hidden', !isChecked)

    if (!isChecked) {
      $('.form-fields .shift_destroy').val('1')
    } else {
      $('.form-fields .shift_destroy').val('0')
    }
  }

  const toggleServiceTypes = () => {
    if (elements.serviceTypeFilter?.checked) {
      $(elements.subscriptionServiceTypes).removeAttr('hidden')
    } else {
      $(elements.subscriptionServiceTypes).attr('hidden', true)
      $(elements.serviceTypeMulti).val(null).multiselect('refresh')
    }
  }

  const toggleCategories = () => {
    if (elements.categoryFilter?.checked) {
      $(elements.subscriptionCategories).removeAttr('hidden')
    } else {
      $(elements.subscriptionCategories).attr('hidden', true)
      $(elements.categoryIdsMulti).val(null).multiselect('refresh')
    }
  }

  const validateFields = (event) => {
    if (elements.serviceTypeFilter?.checked && $(elements.serviceTypeMulti).val() === null) {
      event.preventDefault()
      alert('Please select Service Types')
    } else if (elements.categoryFilter?.checked && $(elements.categoryIdsMulti).val() === null) {
      event.preventDefault()
      alert('Please select Categories')
    } else if (elements.promotionRuleFilter?.checked &&
      $(elements.generalDiscount).val() === 'true' &&
      $(elements.discountMulti).val() === null) {
      event.preventDefault()
      alert('Please select General discounts')
    }
  }

  const toggleGeneralDiscount = () => {
    if (elements.promotionRuleFilter?.checked) {
      $(elements.promotionRuleFields).removeAttr('hidden')
    } else {
      $(elements.promotionRuleFields).attr('hidden', true)
      $(elements.enableDiscountFields).attr('hidden', true)
      $(elements.generalDiscount).val('false')
      $(elements.discountMulti).val([])
      $(elements.cashbackDiscount).val('false')
      $(elements.enableTopListing).val('false')
      $(elements.enableM4bPortal).val('false')
    }
  }

  const toggleFieldsOnGeneralDiscount = () => {
    if ($(elements.generalDiscount).val() === 'true') {
      $(elements.enableDiscountFields).removeAttr('hidden')
    } else {
      $(elements.enableDiscountFields).attr('hidden', true)
    }
  }

  const initializeMultiselect = (elementId) => {
    $(elementId).multiselect({
      enableFiltering: true,
      enableCaseInsensitiveFiltering: true,
      maxHeight: 250,
      buttonWidth: '100%'
    })
  }

  const intializeDateTimePicker = () => {
    initializeMultiselect(elements.serviceTypeMulti)
    initializeMultiselect(elements.categoryIdsMulti)
    initializeMultiselect(elements.discountMulti)
    initializeDataTable(elements.indexListingTable)
    initializeDataTable(elements.showListingTable)
    initializeDataTable(elements.serviceTypesTable)
    initializeDataTable(elements.categoriesTable)

    let startDate = elements.startDate?.value?.split(' ')[0]
    const endDate = elements.endDate?.value?.split(' ')[0]
    const date = new Date()
    const day = date.getDate()
    const year = date.getFullYear()
    const monthName = date.toLocaleString('default', { month: 'long' })
    const controllerAction = elements.subscriptionForm?.getAttribute('data-controller-action')

    if (moment() > moment(startDate)) {
      startDate = moment(startDate)
    } else {
      startDate = moment().millisecond(0).second(0).minute(0).hour(0)
    }

    $(elements.startDate).datetimepicker({
      format: 'YYYY-MM-DD',
      minDate: startDate,
      defaultDate: new Date()
    })

    $(elements.endDate).datetimepicker({
      format: 'YYYY-MM-DD',
      useCurrent: false,
      minDate: startDate,
      defaultDate: new Date(`${monthName} ${day}, ${year}`)
    })

    if (controllerAction === 'edit' || controllerAction === 'update') {
      const minDate = moment(startDate)
      const maxDate = moment(endDate)

      $(elements.endDate).data('DateTimePicker').minDate(minDate)
      $(elements.startDate).data('DateTimePicker').maxDate(maxDate)
    }

    (function () {
      const script = document.createElement('script')
      script.src = 'https://cdn.jsdelivr.net/npm/flatpickr'
      document.head.appendChild(script)
    })()
  }

  if (window.location.pathname.includes('subscription_promotions')) {
    initializeSelectors()
    intializeDateTimePicker()
    initializeListeners()
    toggleShifts()
    toggleServiceTypes()
    toggleCategories()
    toggleGeneralDiscount()
    toggleFieldsOnGeneralDiscount()
  }
}

export default SubscriptionPromotion
